import React, { Ref } from 'react';

import AlertCard from '../../components/alert-card/alert-card';
import { OptionProps, RadioButtons, radioErrorMessage } from '../../components/radio-buttons/radio-buttons';
import { SvarId } from '../../types/generated-types';
import { generateDataTrackIdForButtonOnKategoriside } from '../../utils/piwik-utils';
import { FocusableHtmlElement } from '../hooks';
import { updateSvarId } from '../reducer/sporsmalsflyt-actions';
import { RadioAlternativ } from '../reducer/sporsmalsflyt-types';
import { useSporsmalsflytDispatch } from '../reducer/sporsmalsflytDispatchProvider';
import { CurrentRadiosporsmal } from './radio-types';

import './radio.scss';

interface RadioFeilmeldingProps {
    alternativer: RadioAlternativ[];
    selectedOptionId?: string;
}

export const RadioFeilmelding = ({ alternativer, selectedOptionId }: RadioFeilmeldingProps) => {
    const selectedOption = alternativer.find(({ id }) => id === selectedOptionId);

    if (selectedOption && selectedOption.feilmelding) {
        return (
            <div className="radio-feilmelding-wrapper">
                <AlertCard tittel={selectedOption.feilmelding.tittel} showIcon={false}>
                    {selectedOption.feilmelding.tekst}
                </AlertCard>
            </div>
        );
    }
    return null;
};

export const toOptions = (alternativer: RadioAlternativ[], kategoriId?: string, prefix = ''): OptionProps[] =>
    alternativer.map((alternative) => ({
        label: alternative.tekst,
        description: alternative.undertekst,
        value: alternative.id,
        id: `${prefix}${alternative.id}`,
        'data-track-id': kategoriId
            ? generateDataTrackIdForButtonOnKategoriside(kategoriId, alternative.id)
            : undefined,
    }));

interface Props {
    currentSporsmal: CurrentRadiosporsmal;
    showFeilmelding: boolean;
    focusOnMount: boolean;
    errorRef?: Ref<FocusableHtmlElement>;
    prefix?: string;
}

export const Radio = ({ currentSporsmal, showFeilmelding, focusOnMount, errorRef, prefix }: Props) => {
    const dispatch = useSporsmalsflytDispatch();

    const onChange = (value: SvarId) => {
        dispatch(updateSvarId(value));
    };

    return (
        <>
            <RadioButtons
                name={`${prefix}${currentSporsmal.sporsmal.id}`}
                label={currentSporsmal.sporsmal.tekst}
                info={currentSporsmal.sporsmal.info}
                ingress={currentSporsmal.sporsmal.ingress}
                options={toOptions(currentSporsmal.sporsmal.alternativer, prefix)}
                selectedOption={currentSporsmal.svarId}
                onChange={onChange}
                errorMessage={radioErrorMessage(showFeilmelding, currentSporsmal.svarId)}
                focusOnMount={focusOnMount}
                errorRef={errorRef}
                key={`radio-sporsmal-${currentSporsmal.sporsmal.id}`}
                radioType={currentSporsmal.sporsmal.radioType}
            />
            <RadioFeilmelding
                alternativer={currentSporsmal.sporsmal.alternativer}
                selectedOptionId={currentSporsmal.svarId}
            />
        </>
    );
};
